import { mesaColorNames } from '@/src/common/theme'
import { maxWidth } from '@/src/common/wrappers/MainWrapper'
import type { ComponentProps } from 'react'
import {
  Keyboard,
  KeyboardAvoidingView as ReactKeyboardAvoidingView,
  KeyboardAvoidingViewProps,
  Platform,
  StyleSheet,
} from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

export function KeyboardAvoidingView({
  children,
  innerContainerStyle,
  ...props
}: ComponentProps<typeof SafeAreaView> & {
  innerContainerStyle?: KeyboardAvoidingViewProps['style']
}) {
  return (
    <SafeAreaView
      edges={['top']}
      onStartShouldSetResponder={() => {
        Keyboard.dismiss()
        return false
      }}
      {...props}
      style={[styles.safeAreaView, props.style]}
    >
      <ReactKeyboardAvoidingView
        // KeyboardAvoidingView has different behavior on iOS and Android
        // React Native recommends setting a different behavior value for each platform
        // Documentation: https://reactnative.dev/docs/keyboardavoidingview#behavior
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={[styles.keyboardAvoidingView, innerContainerStyle]}
      >
        {children}
      </ReactKeyboardAvoidingView>
    </SafeAreaView>
  )
}

const safeAreaView = {
  flex: 1,
  backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
  overflowY: 'scroll',
} as const satisfies ComponentProps<typeof SafeAreaView>['style']

const keyboardAvoidingView = {
  marginHorizontal: 'auto',
  paddingHorizontal: 14,
  maxWidth: maxWidth / 2,
} as const satisfies KeyboardAvoidingViewProps['style']

const styles = StyleSheet.create(
  Platform.OS === 'web'
    ? ({ safeAreaView: { paddingTop: 16, ...safeAreaView }, keyboardAvoidingView } as const)
    : ({
        safeAreaView,
        keyboardAvoidingView: { flex: 1, paddingVertical: 10, ...keyboardAvoidingView },
      } as const),
)
